export default function yearsHelper() {
  const results = [
    {
      persian: 1366,
      global: 1987,
    },
  ];

  const thisYear = new Date().getFullYear() > 2021 ? new Date().getFullYear() : 2022; // Make sure the browser date is correct

  for (let i = 1; i <= thisYear - results[0].global; i++) {
    results.push({
      persian: results[0].persian + i,
      global: results[0].global + i,
    });
  }

  return results.reverse();
}
